import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import { FormEvent } from "react";
import { Button, Identifier, useDataProvider } from "react-admin";

import { useForm, useMutation } from "../../../hooks";
import {
  AccountResponse,
  CustomDataProvider,
  ModalProps,
  Region,
  US_REGION,
} from "../../../types";
import { ActionButtonsBar, Form, Modal, RegionSelectInput } from "..";

interface EnableAccountRegionModalProps extends ModalProps {
  account: AccountResponse;
}

interface FormState {
  accountId: Identifier;
  region: Region;
}

function EnableAccountRegionModal(props: EnableAccountRegionModalProps) {
  const defaultFormState: FormState = {
    accountId: props.account.id,
    region: US_REGION,
  };

  const { form, handleChangeForm, handleClearForm } = useForm(defaultFormState);

  const dataProvider = useDataProvider<CustomDataProvider>();
  const { mutate } = useMutation(
    (form: FormState) =>
      dataProvider.enableAccountRegion(form.region, form.accountId),
    ["enableAccountRegion", form],
    "Region has been enabled for the account! ✅",
  );

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    handleClearForm();
    props.handleClose();
    mutate(form);
  };

  return (
    <Modal open={props.modalOpen} title="Enable Account Region">
      <Form onSubmit={handleSubmit}>
        <Typography component="p" sx={{ color: "fieldwire.gray.1" }}>
          Select a region to enable for the account. Once enabled, a region
          cannot be disabled.
        </Typography>
        <TextField
          label="Account Id"
          name="accountId"
          value={form.accountId}
          required
          disabled
        />
        <RegionSelectInput
          label="Region"
          name="region"
          onChange={handleChangeForm}
          value={form.region}
          required
        />
        <ActionButtonsBar>
          <Button
            label="Cancel"
            onClick={props.handleClose}
            variant="fieldwire-secondary"
          />
          <Button
            label="Enable"
            type="submit"
            variant="fieldwire-primary"
            disabled={!form.region}
          />
        </ActionButtonsBar>
      </Form>
    </Modal>
  );
}

export default EnableAccountRegionModal;
